module.exports = __webpack_public_path__ + "static/epic-70f07bdeb5bb07eec95a07678d59be8c.png";